var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "p",
        {
          staticClass:
            "mb-5 font-semibold text-center text-3xl font-strict mt-2",
        },
        [_vm._v(" New Subscription Plan ")]
      ),
      _c("span", { staticClass: "py-5" }, [
        _c("p", { staticClass: "mb-2 text-center text-md font-strict" }, [
          _vm._v(" Current Premium Plan "),
          _c("span", { staticClass: "font-bold ml-2" }, [_vm._v("$149")]),
        ]),
        _c("p", { staticClass: "text-center font-strict" }, [
          _vm._v(
            " " +
              _vm._s(_vm.getSelectedNumberOfManagers) +
              " Additional Managers "
          ),
          _c("span", { staticClass: "font-bold ml-2" }, [
            _vm._v(
              "$" +
                _vm._s(
                  _vm.selectedSubscriptionPlanId
                    ? Number(_vm.managersPrice.replace("$", "")) - 149
                    : ""
                )
            ),
          ]),
        ]),
      ]),
      _c("ModalSectionsDivider"),
      _c("PricePlanProvider", {
        staticClass: "flex-shrink-0 pt-5",
        attrs: {
          subscriptionDetails: _vm.subscription,
          innerName: _vm.innerSubscriptionName,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ price, benefitsShown }) {
                return [
                  _c(
                    "div",
                    { staticClass: "mb-5" },
                    [
                      benefitsShown
                        ? _c("PriceCardViewPricing", {
                            attrs: {
                              price: price,
                              managersCount: _vm.managersCount,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("ModalSectionsDivider"),
                  _c(
                    "div",
                    { staticClass: "flex pt-5" },
                    [_vm._t("default")],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }